import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './components/Home';
import Products from './components/Products';
import Services from './components/Services';
import About from './components/About';
import Contact from './components/Contact';
import Cart from './components/Cart';
import Navbar from './components/Navbar';
import MobileCTA from './components/MobileCTA';
import Footer from './components/Footer';

// Admin Components
import AdminLogin from './components/admin/AdminLogin';
import AdminDashboard from './components/admin/AdminDashboard';
import ProductManager from './components/admin/ProductManager';
import Messages from './components/admin/Messages';
import ProtectedRoute from './components/admin/ProtectedRoute';
import NotificationPanel from './components/NotificationPanel';

import './App.css';

function App() {
  const mockUser = { username: 'demo-user' };
  const mockSignOut = () => console.log('Sign out clicked');

  return (
    <Router>
      <div className="App">
        <NotificationPanel />
        <Routes>
          {/* Admin Routes */}
          <Route path="/admin" element={<AdminLogin />} />
          <Route path="/admin/dashboard" element={
            <ProtectedRoute>
              <AdminDashboard />
            </ProtectedRoute>
          } />
          <Route path="/admin/products" element={
            <ProtectedRoute>
              <ProductManager />
            </ProtectedRoute>
          } />
          <Route path="/admin/messages" element={
            <ProtectedRoute>
              <Messages />
            </ProtectedRoute>
          } />
          
          {/* Public Routes */}
          <Route path="/*" element={
            <>
              <Navbar signOut={mockSignOut} user={mockUser} />
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/products" element={<Products />} />
                <Route path="/services" element={<Services />} />
                <Route path="/about" element={<About />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/cart" element={<Cart />} />
              </Routes>
              <MobileCTA />
              <Footer />
            </>
          } />
        </Routes>
      </div>
    </Router>
  );
}

export default App;